module.exports = __webpack_public_path__ + "static/img/住院清单@3x.43244ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/住院清单@3x.png
// module id = 306
// module chunks = 379 380